module.exports = __webpack_public_path__ + "static/media/uwnyc.b0670faf.png";